import { load } from 'poly-eshop4/eshop/ui/js/util';

$(document)
  .off('submit', '[data-fastentry-form]')
  .on('submit', '[data-fastentry-form]', function(event) {
    event.preventDefault();
    const app = $(this).attr('data-fastentry-form');
    const isReel = $(this).attr('data-reels');
    const hasContract = $(this).attr('data-contracts');

    if (isReel || hasContract) {
      const $qty = $(this).find('input[name="quantity"]');
      const data = {};
      data.app = app;
      if ($qty && $qty.val() !== '') {
        data.quantity = $qty.val();
      }

      $.ajax({
        method: 'GET',
        url: isReel || hasContract,
        data,
      }).done((resp) => {
        const element = $(resp).appendTo($('body'));
        element.foundation().foundation('open');
        $.stores.fastEntry.clear(true);
        $('[data-fastentry-item]').val('').get(0).focus();
      });
    } else {
      let positionCount = $(this).attr('data-fastentry-position-count');
      positionCount = positionCount ? parseInt(positionCount, 10) : 0;
      const $reveal = $('[data-add-to-cart-ask-reveal="fastentry"]');
      if (positionCount === 1 && $reveal.length) {
        const $overwritePosBtn = $reveal.find('[data-add-to-cart-overwrite-pos]');
        const $appendPosBtn = $reveal.find('[data-add-to-cart-append-pos]');

        const action = $(this).attr('action');
        const idx = action.indexOf('?');
        const host = idx >= 0 ? action.substr(0, idx) : action;
        const params = new URLSearchParams(idx >= 0 ? action.substr(idx) : '');

        $overwritePosBtn.on('click', () => {
          $overwritePosBtn.unbind('click');
          $appendPosBtn.unbind('click');
          params.set('behaviour', 'OVERWRITE_POS');
          load(this, $.stores[app].post(`${host}?${params.toString()}`, $(this).serializeArray()));
          $.stores.fastEntry.clear(true);
          $('[data-fastentry-item]').val('').get(0).focus();
          $reveal.foundation('close');
        });
        $appendPosBtn.on('click', () => {
          $overwritePosBtn.unbind('click');
          $appendPosBtn.unbind('click');
          params.set('behaviour', 'APPEND_POS');
          load(this, $.stores[app].post(`${host}?${params.toString()}`, $(this).serializeArray()));
          $.stores.fastEntry.clear(true);
          $('[data-fastentry-item]').val('').get(0).focus();
          $reveal.foundation('close');
        });
        $reveal.foundation('open');
      } else {
        load(this, $.stores[app].post($(this).attr('action'), $(this).serializeArray()));
        $.stores.fastEntry.clear(true);
        $('[data-fastentry-item]').val('').get(0).focus();
      }
    }
  });

$(document).on('keyup', '[data-fastentry-item]', function(event) {
  const hasItemId = $(this).closest('[data-fastentry-form]').find('input[name="item_id"]').val();
  if ($(this).val().match(/[0-9]{9}/) && hasItemId !== $(this).val()) {
    event.preventDefault();
    event.stopPropagation();
    $.stores.fastEntry.fetchItemInfo(
      $(this).closest('[data-fastentry-form]').attr('data-action-info'),
      $(this).val(),
    ).then(() => {
      setTimeout(() => {
        $(this).closest('[data-fastentry-form]').find('[data-fastentry-quantity]').trigger($.Event('click'));
      }, 10);
    });
  }
});
